import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import logo from '../../assets/logos/icare_fulllogo.png';
import { AppContext } from '../../Base';
import Footer1 from '../../components/nav/Footer1';
import { readCookie, sendReactGAPageView } from '../../consts/helpers';

export default function LogoutPage() {
	const { pathname } = useLocation();
	useEffect(() => {
        sendReactGAPageView(pathname, 'Log Out');
    }, [pathname])

    const setSessionCookie = useContext(AppContext).setSessionCookie;
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');

    // Stage flags
    const [isLoading, setLoading] = useState(false);
    const [isSuccessful, setSuccess] = useState(false);

    const url = process.env.REACT_APP_USERACCESS_LAMBDA;
    const handleLogoutAttempt = () => {
        setLoading(true);
        fetch(url, {
            method: 'DELETE',
            body: JSON.stringify({
                'email': email,
                'token': token,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(
            function (response) {
                return response.json();
            }
        ).then(
            function(data) {
                setSuccess(data?.loggedOut);
                if (data?.loggedOut) setSessionCookie();
                else navigate(-1); // go back
                setLoading(false);
            }
        ).catch(
            function(error) {
                console.log("LOGOUT:", error)
            }
        );
    }

    useEffect(() => {
        setEmail(readCookie('icare_se'));
        setToken(readCookie('icare_st'));
    },[]);

    useEffect(() => {
        if (email && token) handleLogoutAttempt();
    },[email, token]);

    return (
        <Box sx={{ flex: 'auto', py: 2 }} className='spread-y'>
        <Box className='centered-container' sx={{ flex: 'auto' }}>
            {
                isLoading ?
                <CircularProgress color='secondary' />
                : isSuccessful ?
                <Stack spacing={2}>
                    <Box className="centered-container">
                        <img src={logo} alt='icare app logo' style={{ maxWidth: 300 }}/>
                    </Box>
                    <Typography variant="h6" align="center" className='green-text-color'>You are successfully logged out!</Typography>
                    <Typography variant="body2" align="center">Thank you for using our application.<br />We hope to see you again.</Typography>
                    
                    <Button 
                        className={'pill_btn pri_btn'}
                        fullWidth 
                        onClick={() => navigate('/login')}
                    >
                        Back to Login
                    </Button>
                </Stack>    
                :
                <Button 
                    className={'pill_btn pri_btn'}
                    fullWidth 
                    onClick={() => navigate('/login')}
                >
                    Back to Login
                </Button>
            }
        </Box>
        <Footer1 />
        </Box>
    )
}
